import './src/styles/tailwind.css';
import './src/styles/global.less';

require('highlight.js/styles/dracula.css');
